import {
  BlockStack,
  Button,
  Card,
  InlineError,
  LegacyStack,
  OptionList,
  Popover,
  Text,
} from '@shopify/polaris'
import React from 'react'

import { Result } from '../common/api'
import { FullWithCardDivider } from '../common/FullWithCardDivider'
import { resultErrorField, useToggle } from '../common/helpers'
import { SellingPlanInterval } from '../common/plan-models'
import {
  WorkflowAction,
  workflowActionLabels,
  WorkflowActionType,
  workflowActionTypes,
  WorkflowInternalActionType,
  workflowInternalActionTypes,
} from '../common/workflow-models'
import { ActionsForm } from './ActionsForm'
import { WorkflowFormData } from './api'

export type ActionOption = {
  label: string
  value: WorkflowActionType
}

export const actionOptions = workflowActionTypes
  .filter((action) => !workflowInternalActionTypes.includes(action as any))
  .map((action) => ({
    label: workflowActionLabels[action],
    value: action,
  }))

export const workflowActionDefaults: Record<
  Exclude<WorkflowActionType, WorkflowInternalActionType>,
  any
> = {
  'add-customer-tags': [],
  'remove-customer-tags': [],
  'add-order-tags': [],
  'remove-order-tags': [],
  'add-one-time-gift-product': [],
  'add-product': [[], 1, '0.00', 1],
  'swap-product': [],
  'remove-product': [],
  'remove-product-variant': [],
  'add-discount': ['', '1', 'percentage', '0'],
  'edit-delivery-frequency': [1, SellingPlanInterval.MONTH, 1],
  'edit-delivery-method': [null, null, null],
}

export interface ActionsCardProps {
  data: WorkflowFormData
  onChange: (actions: WorkflowAction[]) => any
  saveResult: Result<any> | null
}

export const ActionsCard = ({ data, onChange, saveResult }: ActionsCardProps) => {
  const [actionPopoverActive, toggleActionPopover] = useToggle(false)
  const error = resultErrorField(saveResult, `actions`)

  return (
    <Card>
      <BlockStack gap="300">
        <Text as="h2" variant="headingMd">
          Actions
        </Text>
        <FullWithCardDivider />
        <ActionsForm
          actions={data.actions}
          triggers={data.triggers}
          onChange={onChange}
          saveResult={saveResult}
        />
        <LegacyStack vertical>
          <Popover
            active={actionPopoverActive}
            activator={
              <Button onClick={toggleActionPopover} disclosure>
                Add action
              </Button>
            }
            onClose={toggleActionPopover}
            fluidContent
          >
            <OptionList
              onChange={(selected: Exclude<WorkflowActionType, WorkflowInternalActionType>[]) => {
                onChange([...data.actions, [selected[0], workflowActionDefaults[selected[0]]]])
                toggleActionPopover()
              }}
              options={actionOptions}
              selected={[]}
            />
          </Popover>
          {error && <InlineError message={error} fieldID={'actions'} />}
        </LegacyStack>
      </BlockStack>
    </Card>
  )
}
